import React, { useState } from 'react';
import Button, { Size as ButtonSize } from '@leafygreen-ui/button';
import { Icon } from '@leafygreen-ui/icon';
import { Menu, MenuItem } from '@leafygreen-ui/menu';
import { palette } from '@leafygreen-ui/palette';

import { stopPropagation } from 'baas-ui/util';

export enum TestSelector {
  ActionButton = 'action-button',
  AddServiceButton = 'add-service-button',
  DeleteServiceButton = 'delete-service-button',
}

interface Props {
  onEdit(): void;
  onDelete(): void;
}

const ServicesActionMenu = ({ onDelete, onEdit }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <Menu
      renderDarkMenu={false}
      open={open}
      setOpen={setOpen}
      trigger={
        <Button
          data-testid={TestSelector.ActionButton}
          size={ButtonSize.XSmall}
          onClick={stopPropagation(() => setOpen(true))}
          data-cy="open-service-actions"
        >
          <Icon glyph="Ellipsis" />
        </Button>
      }
      renderMode="portal"
    >
      <MenuItem
        onClick={stopPropagation(() => {
          setOpen(false);
          onEdit();
        })}
      >
        Edit Service
      </MenuItem>
      <MenuItem
        data-testid={TestSelector.DeleteServiceButton}
        onClick={stopPropagation(() => {
          setOpen(false);
          onDelete();
        })}
        data-cy="delete-service"
        style={{ color: palette.red.base }}
      >
        Delete Service
      </MenuItem>
    </Menu>
  );
};

export default ServicesActionMenu;
